/**
 * Sales Rep Search component with division tabs.
 *
 * Each division tab has its own form with isolated input fields so ZIP input
 * in one tab is never carried over when clicking another tab.
 */
export default function SalesRepSearch(el) {
    const tabs = Array.from(el.querySelectorAll('[data-division-tab]'));
    const panels = Array.from(el.querySelectorAll('[data-division-panel]'));

    if (!tabs.length || !panels.length) {
        return;
    }

    function activateTab(targetSlug, setFocus = false) {
        tabs.forEach(tab => {
            const isActive = tab.getAttribute('data-division-tab') === targetSlug;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.setAttribute('tabindex', isActive ? '0' : '-1');
            if (isActive && setFocus) {
                tab.focus();
            }
        });

        panels.forEach(panel => {
            const isTarget = panel.getAttribute('data-division-panel') === targetSlug;
            panel.hidden = !isTarget;
            panel.classList.toggle('is-active', isTarget);
        });
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            const slug = tab.getAttribute('data-division-tab');
            activateTab(slug);
        });

        tab.addEventListener('keydown', e => {
            let nextIndex = null;
            if (e.key === 'ArrowRight') {
                nextIndex = (index + 1) % tabs.length;
            } else if (e.key === 'ArrowLeft') {
                nextIndex = (index - 1 + tabs.length) % tabs.length;
            } else if (e.key === 'Home') {
                nextIndex = 0;
            } else if (e.key === 'End') {
                nextIndex = tabs.length - 1;
            }

            if (nextIndex !== null) {
                e.preventDefault();
                const nextSlug = tabs[nextIndex].getAttribute('data-division-tab');
                activateTab(nextSlug, true);
            }
        });
    });
}
